export const LEXICAL_SHARE_TYPES = ["PRIVATE", "LINK", ""];

export const PROVIDER_TYPES = ["EMAIL", "CNP", "PHONE", "SYSADMIN", "GOOGLE", "DISCORD"] as const;

export const RATE_SPLIT_TYPES = ["trimestrial", "anual", "lunar", "semestrial", "unic"] as const;

export const PROCEDURE_CATEGORIES = ["DIGITAL_IDENTITY", "GENERAL"] as const;

export const ORG_CHART_NODE_TYPES = ["INSTITUTION", "SERVANT", "DEPARTMENT"] as const;

export const PROCEDURE_TRIGGER_EVENTS: (typeof PROCEDURE_ACTION_TYPES)[number][] = [
  "FORM_SUBMITTED",
  "MEETING_STARTED",
  "MEETING_PRE_STARTED",
  "SIGNATURE_VERIFICATION_REQUESTED",
  "SIGNATURE_DELEGATION_REQUESTED",
  "SIGNATURE_DELEGATION_REVOCATION_REQUESTED",
] as const;

export const UI_USER_TYPE = ["PUBLIC_SERVANT", "CITIZEN", "ADMIN"] as const;

export const PROCEDURE_ACTION_TYPES = [
  "ADD_FORM",
  "ADD_TO_REGISTRY",
  "ADD_WORKTABLE_DOCUMENT",
  "ASSIGN",
  "CHOOSE_SIGNERS",
  "COLLABORATIVE_DOCUMENT",
  "COMMIT_DOCUMENT",
  "CREATE_DIGITAL_IDENTITY",
  "DELEGATE_SIGNATURE",
  "DUMMY_ACTION",
  "FORM_SUBMITTED",
  "GENERATE_TEMPLATE_DOCUMENT",
  "LOG_DATA",
  "MEETING_PRE_STARTED",
  "MEETING_STARTED",
  "REVOKE_SIGNATURE_DELEGATION",
  "SIGNATURE_DELEGATION_REQUESTED",
  "SIGNATURE_DELEGATION_REVOCATION_REQUESTED",
  "SIGNATURE_REQUEST",
  "SIGNATURE_VERIFICATION_REQUESTED",
  "SIGN_BY_INSTITUTION",
  "UPLOAD_DOCUMENT",
  "VALIDATE_DIGITAL_IDENTITY",
  "VALIDATE_SIGNATURE",
  "WAIT_FOR_MEETING_END",
  "MEETING_DATA_FUNCTION",
  "CITIZEN_DATA_FUNCTION",
  "INSTITUTION_DATA_FUNCTION",
  "DOCUMENT_FILL_IN_DATA_EXTRACT_FUNCTION",
  "TAX_FUNCTION",
  "CREATE_FOLDER",
  "DOCUMENT_SIGNED_TRIGGER",
  "MANUAL_REGISTRATION_CREATED",
  "PLATFORM_NOTIFICATION",
  "EMAIL_NOTIFICATION",
  "PROJECT_ADDED",
] as const;

export const RUNNING_STEP_EVENT_TYPES = ["STEP_MOVED"] as const;

export const REGISTRATURE_DEFAULT_COLUMNS = ["TYPE", "NUMBER", "DATE"] as const;

export const EVENT_TYPES = [
  "FORM_SUBMITTED",
  "LOCAL_COUNCIL_MEETING_STARTED",
  "LOCAL_COUNCIL_MEETING_PRE_STARTED",
  "SIGNATURE_VERIFICATION_REQUESTED",
  "SIGNATURE_DELEGATION_REQUESTED",
  "SIGNATURE_DELEGATION_REVOCATION_REQUESTED",
  "DOCUMENT_SIGNED",
  "MANUAL_REGISTRATION",
  "PROJECT_ADDED",
] as const;

export const PROCEDURE_STATUS = ["ERROR", "FINISHED", "STARTED", "IN_PROGRESS", "STOPPED"] as const;

export const CADASTRAL_ZONE_TYPES = [
  "PARCEL",
  "BUILDING",
  "ROAD",
  "PARKING",
  "URBAN_PLAN",
] as const;

export const PROCEDURE_STEP_STATUS = [
  "IN_PROGRESS",
  "WAITING_FOR_MANUAL_CONFIRMATION",
  "PREPARE",
  "ERROR",
  "FINISHED",
  "SKIPPED",
  "WAITING_MANUAL_ROLLBACK",
] as const;

export const TIP_CREANTA = [
  "CREANTE_BUGET_LOCAL",
  "CREANTE_BUGET_STAT",
  "CREANTE_VENITURI_PROPRII",
] as const;

export const TAX_DOCUMENT_TYPES = [
  "CHITANTA",
  "OP",
  "VIRAMENT/COMPENSARE",
  "RESTITUIRI",
  "ALTE DOCUMENTE",
  "NOTA_CONTABILA",
  "PLATA_CARD",
  "ALTE_VIRAMENTE",
  "BORDEROU_REDUCERE_MAJORARI_50%",
  "BORDEROU_REDUCERE_MAJORARI_25%",
  "TRANSFER_AVANS_ALT_ROL",
  "PLATA_ONLINE",
  "MANDAT_POSTAL",
  "REFERAT_RESTITUIRE_SUME_NECUVENIT",
] as const;

export const BLOCKCHAIN_FORM_STATUS = ["WAITING_CONFIRMATION", "NOT_SENT", "CONFIRMED"] as const;

export const PROPERTY_TYPES = ["HOUSE", "LAND", "VEHICLE"] as const;

export const DEBIT_TYPES = [
  "BUILDING",
  "LAND",
  "VEHICLES",
  "TAXES_AUTHORIZATIONS",
  "SHOWS",
  "OTHER",
  "CONCESSION",
  "FINES",
] as const;

export const FAMILY_RELATION_TYPES = ["BROTHER", "MOTHER", "FATHER", "SON"] as const;

export const TAX_GROUP_MEMBER_TYPES = [
  "OWNER",
  "HOME_HEAD",
  "SPOUSE",
  "CHILD",
  "OTHER",
  "UNRELATED",
] as const;

export const FORM_TYPES = ["CUSTOM", "COMMON", "SYSTEM", "GENERATED"] as const;

export const VALIDATOR_TYPES = [
  "REQUIRED",
  "LENGTH",
  "CLIENT_SIDE_DYNAMIC",
  "ZONE_LIMIT",
  "PERSONAL_CODE",
  "PERSONAL_CODE_UNIQUE",
  "REGEX",
] as const;

export const ELEMENT_TYPES = [
  "TEXT_BOX",
  "SELECT",
  "CHECKBOX",
  "TABLE",
  "FILE",
  "FILE_MULTIPLE",
  "DATE",
  "NUMBER",
  "LINK",
  "LOCATION",
  "TEXT_AREA",
  "TEXT",
  "GAP",
] as const;

export const SERVICE_PACKAGE_TYPES = [
  "accounting",
  "taxes_and_fees",
  "worktable",
  "registry",
  "uat",
  "urbanism",
  "procedures",
  "citizens",
  "local_council",
  "budget_planning",
] as const;

export const DIGITAL_SIGNATURE_TYPES = ["USB", "CLOUD", "LOCAL"] as const;

export const WORKTABLE_FOLDER_STATUS = ["OPEN", "FROZEN", "SEALED"] as const;

export const SEND_NOTIFICATION_CATEGORIES = [
  "CUSTOM",
  "SOLICITATION_UPDATED",
  "FORM_SUBMITTED_CITIZEN",
  "WORKTABLE_DOCUMENT_ACCESS_GRANTED",
  "WORKTABLE_FOLDER_ACCESS_GRANTED",
] as const;

export const MEETING_STATUS_TYPES = [
  "draft",
  "published",
  "pending",
  "ongoing",
  "completed",
  "cancelled",
] as const;

export const LOCAL_COUNCIL_PROJECT_STATUS = [
  "draft",
  "public-view",
  "ready-to-publish",
  "pending",
  "approved",
  "rejected",
  "not-started",
  "in-progress",
  "voting-started",
  "withdrawn",
] as const;

export const LOCAL_COUNCIL_AMENDMENT_STATUS = [
  "pending",
  "approved",
  "rejected",
  "not-started",
  "in-progress",
  "voting-started",
] as const;

export const LOCAL_COUNCIL_COMMISSION_ROLES = ["MEMBER", "SECRETARY", "PRESIDENT"] as const;

export const LEXICAL_DOCUMENT_TYPES = ["COMMON", "SMART-DOCUMENT"] as const;

export const CREATED_BY_ENTTY_TYPES = ["USER", "PROCEDURE", "LOCAL_COUNCIL"] as const;

export const VOTE_TYPES = ["for", "against", "abstain", "absent", "pending"] as const;

export const BUDGET_ENTRY_TYPES = ["INCOME", "EXPENSE"] as const;
export const BUDGET_STATUS = ["draft", "in-review", "published", "adjusting"] as const;

export const INVENTORY_EXIT_TYPES = ["donation", "sell", "destroy"] as const;

export const CURRENCY_TYPES = ["RON", "EUR", "USD"] as const;
export const INVOICE_STATUS = ["pending", "paid", "cancelled"] as const;

export const ISSUES_AND_REPORTS_CATEGORY_SLUG = "reportmapproblem";
export const DIGITAL_IDENTITY_CATEGORY_SLUG = "identitate-digitala-persoane";
export const GENERATED_FORMS_CATEGORY_SLUG = "generated-forms";
export const CONTRACT_SYSTEM_FORMS_TEMPLATE_CATEGORY_SLUG = "contract-system-forms-template";
export const IGNORED_CATEGORIES_SLUGS = [
  ISSUES_AND_REPORTS_CATEGORY_SLUG,
  DIGITAL_IDENTITY_CATEGORY_SLUG,
  GENERATED_FORMS_CATEGORY_SLUG,
  CONTRACT_SYSTEM_FORMS_TEMPLATE_CATEGORY_SLUG,
] as const; // categories that should not be displayed in the public page

export const DIGITAL_IDENTITY_STATUSES = ["PENDING", "VERIFIED", "REJECTED"] as const;
export const PROFILE_TYPE = ["CITIZEN", "PUBLIC_SERVANT", "LEGAL_ENTITY"] as const;

export const DIGITAL_IDENTITY_GROUP_NAME = "Identitate digitala";
export const COMPANY_DIGITAL_IDENTITY_CATEGORY_NAME = "Identitate digitala (firme)";
export const PERSON_DIGITAL_IDENTITY_CATEGORY_NAME = "Identitate digitala (persoane)";

export const CONTRACT_STATUS = ["DRAFT", "IN-REVIEW", "SIGNED"] as const;

export const PUBLIC_AQUISITIONS_PUBLIC = "licitatii-publice";
export const PUBLIC_AQUISITIONS_DIRECT = "achizitii-directe";
export const PUBLIC_AQUISITIONS_OFFLINE = "achizitii-offline";

export const PUBLIC_AQUISITION_STATUS = [
  "Cerere de oferta",
  "Licitatie deschisa",
  "Licitatie deschisa accelerata",
  "Licitatie restransa",
  "Negociere fara publicare prealabila",
  "Norme proprii (Anexa 2)",
  "Procedura simplificata",
  "Procedura simplificata proprie",
] as const;

export const SIGNATURE_STATUS = ["PENDING", "ACTIVE", "REVOKED"] as const;

export const AGE_BRACKETS = [
  "0-4",
  "5-9",
  "10-14",
  "15-19",
  "20-24",
  "25-29",
  "30-34",
  "35-39",
  "40-44",
  "45-49",
  "50-54",
  "55-59",
  "60-64",
  "65-69",
  "70-74",
  "75-79",
  "80-84",
  "85+",
] as const;

export const PUBLIC_AQUISITIONS_TYPE = [
  PUBLIC_AQUISITIONS_DIRECT,
  PUBLIC_AQUISITIONS_PUBLIC,
  PUBLIC_AQUISITIONS_OFFLINE,
] as const;
